import { addressDefaultValue } from "./addressFieldConfig";
import { mobileNumberDefaultValue } from "./mobileFieldConfig";
import { emailDefaultValue } from "./emailFieldConfig";
import { nameDefaultValue } from "./nameFieldConfig";
import { numberDefaultValue } from "./numberFieldConfig";
import { urlDefaultValue } from "./urlFieldConfig";
import { sectionDefaultValue } from "./sectionFieldConfig";
export enum PreDefinedFormFieldTypes {
  ADDRESS = "ADDRESS",
  MOBILE = "MOBILE",
  EMAIL = "EMAIL",
  NAME = "NAME",
  URL = "URL",
  SECTION = "SECTION",
}
export enum PreDefinedFormFieldNames {
  ADDRESS = "Address",
  MOBILE = "Phone",
  EMAIL = "Email",
  NAME = "Name",
  NUMBER = "Number",
  URL = "Website",
  SECTION = "Section",
}

export const getPreDefinedFormFields = (FormFieldType: string): any => {
  let fieldDefaultValue = {};
  switch (FormFieldType) {
    case PreDefinedFormFieldTypes?.ADDRESS:
      fieldDefaultValue = addressDefaultValue;
      break;
    case PreDefinedFormFieldTypes?.MOBILE:
      fieldDefaultValue = mobileNumberDefaultValue;
      break;
    case PreDefinedFormFieldTypes?.EMAIL:
      fieldDefaultValue = emailDefaultValue;
      break;
    case PreDefinedFormFieldTypes?.NAME:
      fieldDefaultValue = nameDefaultValue;
      break;
    case PreDefinedFormFieldTypes?.URL:
      fieldDefaultValue = urlDefaultValue;
      break;
    case PreDefinedFormFieldTypes?.SECTION:
      fieldDefaultValue = sectionDefaultValue;
      break;
    default:
      break;
  }
  return fieldDefaultValue;
};
